
import React, { useState, useEffect } from 'react';
import WhatsAppStatusScreen from '../components/WhatsAppStatusScreen.js';
import LeftPane from '../../components/LeftPane.js';
import Header from '../../components/Header.js';
import { getwhatsAppPartnerInfo } from '../../services/apiServices';
import WhatsAppEmbeddedSignup from '../components/GymWhatsappRegistration.js';
import WhatsAppSignup from './WhatsAppSignup.js';

const WhatsAppConnect = () => {
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [partnerData, setPartnerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function checkRegistrationStatus() {
            try {
                setLoading(true);
                const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

                if (!gymid) {
                    setError("No gym ID found");
                    setLoading(false);
                    return;
                }

                const partnerResponse = await getwhatsAppPartnerInfo(gymid);

                if (partnerResponse && partnerResponse !== "false") {
                    const partnerinfo = await partnerResponse.json();
                    console.log(partnerinfo, 'partnerinfo');

                    if (partnerinfo?.data) {
                        // Gym has submitted registration
                        setHasSubmitted(true);
                        setPartnerData(partnerinfo.data);
                    } else {
                        // No registration found
                        setHasSubmitted(false);
                    }
                } else {
                    // API error or no data
                    setHasSubmitted(false);
                }
            } catch (error) {
                console.error("Error checking registration status:", error);
                setError("Failed to load registration status");
                setHasSubmitted(false);
            } finally {
                setLoading(false);
            }
        }

        checkRegistrationStatus();
    }, []);


    const handleRegistrationSuccess = (partnerInfo) => {
        console.log(partnerInfo, "partnerInfo");

        setHasSubmitted(true);
        setPartnerData(partnerInfo);
    };
    console.log(hasSubmitted, 'hasSubmitted');

    if (loading) {
        return (
            <div className="gym-container">
                <LeftPane isactive="16" />
                <Header />
                <div className="gym-main gym-main-div rightContent">
                    <div className="gym-container gym-cnr" id="showcase">
                        <div className="loading-container">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading WhatsApp registration status...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="gym-container">
                <LeftPane isactive="16" />
                <Header />
                <div className="gym-main gym-main-div rightContent">
                    <div className="gym-container gym-cnr" id="showcase">
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="gym-container">
            <LeftPane isactive="16" />
            <Header />
            <div className="gym-main gym-main-div rightContent">
                <div className="gym-container gym-cnr" id="showcase">
                    {hasSubmitted ? (
                        <WhatsAppStatusScreen
                            partnerData={partnerData}
                            onEditRegistration={() => setHasSubmitted(false)}
                        />
                    ) : (
                        // <WhatsAppEmbeddedSignup
                        //     onRegistrationSuccess={handleRegistrationSuccess}
                        // />
                        <WhatsAppSignup onRegistrationSuccess={handleRegistrationSuccess}
                        />

                    )}
                </div>
            </div>
        </div>
    );
};

export default WhatsAppConnect;